<template>
  <div class="marker-action" tabindex="0">
    <list-action-form
      v-if="validSelection"
      ref="form"
      :ids="ids"
      :labels="labels"
      :route="route"
      :method="method"
      @submitted="confirmSubmit"
    >
    </list-action-form>
    <popover v-else ref="popover" placement="bottom" trigger="hover">
      <a class="marker-action-button" disabled="true" @click.prevent>{{
        labels.button
      }}</a>
      <div slot="content">
        {{ labels.invalidSelection }}
      </div>
    </popover>
    <modal
      v-model="showModal"
      :title="labels.confirmModalTitle"
      :header="false"
      :confirm-button-label="labels.ok"
      :close-button-label="labels.cancel"
      @closed="showModal = false"
      @confirmed="submit"
    >
      <button
        id="close"
        slot="before-content"
        @click.prevent="showModal = false"
      >
        <i class="af-icons af-icons-cross"></i>
      </button>
      {{ modalBody }}
    </modal>
  </div>
</template>

<script>
import ListAction from './ListAction.vue';
import { Modal, Popover } from 'vue-bootstrap';

/**
 * The Deletism component.
 */
export default {
  components: {
    Modal,
    Popover
  },
  extends: ListAction,
  props: {
    validateIds: {
      type: Boolean,
      default: false
    },
    validIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    validSelection() {
      if (!this.validateIds || this.ids.length === 0) {
        return true;
      }

      return this.ids.every(id => this.validIds.includes(id));
    },
    modalBody() {
      const id =
        this.ids.length > 1 ? 'alerts-delete-items' : 'alerts-delete-item';
      const element = document.getElementById(id);

      return element ? element.textContent : '';
    }
  },
  methods: {
    confirmSubmit() {
      this.showModal = true;
    }
  }
};
</script>
